module.exports = __webpack_public_path__ + "static/media/mysqlpic.af0dad0a.png";